(ns kyber.db.session
  (:require [clojure.spec.alpha :as s]))

(def initial-state {:cognito-session nil
                    :user nil
                    :refresh-time nil})

(s/def ::email string?)
(s/def ::email-verified string?) ;; NOTE returns the string "true" or "false"
(s/def ::sub string?)
(s/def ::groups (s/and set? (s/coll-of string?)))
(s/def ::user (s/nilable (s/keys :opt-un [::email
                                          ::email-verified
                                          ::sub
                                          ::groups])))
(s/def ::refresh-time (s/nilable number?))
(s/def ::cognito-session (s/nilable any?))
(s/def :kyber.db/session (s/keys :req-un [::cognito-session
                                          ::user]
                                 :opt-un [::refresh-time]))
